import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { TheSeatEmbedCollectionWidget } from './TheSeatEmbedCollectionWidget'

export const SeatEmbedWidgetCollectionRegistration =
    createRegisterableComponent('election-seat-embed-collection-widget', () => {
        return <TheSeatEmbedCollectionWidget />
    })
